
import React, { useState } from "react";
import { TasksView } from "./TasksPage";
import { LegalWorkLogView } from "./LegalWorkLogPage";
import { useAuth } from "../context/AuthContext";
import { canViewWorklog } from "../config/roles";

export function TasksAndLogsPage() {
  const { user } = useAuth();
  const [activeTab, setActiveTab] = useState<'TASKS' | 'LOGS'>('TASKS');

  // Strict Access Control: KC & AD only
  if (!canViewWorklog(user?.email)) {
      return (
        <div style={{
            height:'100%', display:'flex', alignItems:'center', justifyContent:'center', 
            flexDirection:'column', color:'var(--danger)'
        }}>
            <h2 style={{margin:0}}>403 Forbidden</h2>
            <p>您的帳號 ({user?.email}) 無權存取工作日誌與待辦管理。</p>
        </div>
      );
  }

  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <div className="row" style={{ borderBottom: '1px solid #333', marginBottom: 16, justifyContent:'space-between', alignItems:'center' }}>
        <div className="row">
            <button 
            className="navbtn" 
            style={{ width: 'auto', borderBottom: activeTab === 'TASKS' ? '2px solid #fff' : 'none', borderRadius: 0, color: activeTab === 'TASKS' ? '#fff' : 'var(--muted)' }}
            onClick={() => setActiveTab('TASKS')}
            >
            待辦事項 (未完成)
            </button>
            <button 
            className="navbtn" 
            style={{ width: 'auto', borderBottom: activeTab === 'LOGS' ? '2px solid #fff' : 'none', borderRadius: 0, color: activeTab === 'LOGS' ? '#fff' : 'var(--muted)' }}
            onClick={() => setActiveTab('LOGS')}
            >
            法務工作日誌 (全部歷程)
            </button>
        </div>
      </div>

      <div style={{ flex: 1, overflowY: 'auto' }}>
        {activeTab === 'TASKS' && <TasksView />}
        {activeTab === 'LOGS' && <LegalWorkLogView />}
      </div>
    </div>
  );
}
